import { IRefIds } from '../../../constants/refs';
import { IRefOption } from '../../../components/RefSelectorList';

export const TRANSLATION_REF_OPTIONS: IRefOption[] = [
  { value: IRefIds.klines, label: 'K-Lines' },
  { value: IRefIds.panelTitle, label: 'Panel Titles' },
  { value: IRefIds.lessonTitle, label: 'Lesson Titles' },
  { value: IRefIds.trainer, label: 'Trainer Titles' },
  { value: IRefIds.panelIntro, label: 'Panel Intro' },
  { value: IRefIds.paragraph, label: 'Paragraphs' },
  { value: IRefIds.tableLiterals, label: 'Table Literals' },
];
